import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "view-container app-successful" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CobraSuccessView = _resolveComponent("CobraSuccessView")!
  const _component_OpenSuccessView = _resolveComponent("OpenSuccessView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.enrollmentType === 0)
      ? (_openBlock(), _createBlock(_component_CobraSuccessView, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.enrollmentType === 1)
      ? (_openBlock(), _createBlock(_component_OpenSuccessView, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.totalEnrollments > 1)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          name: "btnEnrollments",
          class: "btn btn-primary save-btn enrollment-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToEnrollments && _ctx.goToEnrollments(...args)))
        }, " Return to Enrollments "))
      : _createCommentVNode("", true)
  ]))
}